import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { RewardedAdStatus } from './rewarded-ad.types';

/**
 * Step 1 fake "ad" player (dev only). Rendered into the dialog's injection div by
 * DummyRewardedAdProvider via createComponent({ hostElement }), so it keeps the
 * provider's "render into an element by id" contract (mirrors the real AppLixir
 * SDK) while still being a normal Angular template with scoped styles.
 *
 * Labels are intentionally NOT internationalised — only ever shown with the dummy
 * provider, never to end users. See handover §2a.
 */
@Component({
    selector: 'dummy-rewarded-player',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './dummy-rewarded-player.component.html',
    styleUrls: ['./dummy-rewarded-player.component.scss'],
})
export class DummyRewardedPlayerComponent implements OnInit, OnDestroy {
    /** Simulated ad length; "Complete" unlocks only once the countdown hits 0. */
    @Input() durationSeconds = 5;
    @Output() finished = new EventEmitter<RewardedAdStatus>();

    remaining = 0;
    rewardReady = false;
    private timer: any;

    ngOnInit(): void {
        this.remaining = Math.max(1, this.durationSeconds);
        this.timer = setInterval(() => {
            this.remaining -= 1;
            if (this.remaining <= 0) {
                clearInterval(this.timer);
                this.rewardReady = true;
            }
        }, 1000);
    }

    ngOnDestroy(): void {
        clearInterval(this.timer);
    }

    settle(status: RewardedAdStatus): void {
        this.finished.emit(status);
    }
}
